import { useEffect, useState } from "react";
import { api } from "@/lib/api";
export default function About() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data || {})); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16">
      <h1 className="display text-5xl md:text-7xl">{s.brand_name || "ABOUT"}</h1>
      <p className="text-neutral-300 text-sm mt-6 leading-relaxed whitespace-pre-line">{s.about || ""}</p>
    </div>
  );
}
